import { WellKnownSymbol } from '../../constants';
import { WellKnownSymbolBase } from './WellKnownSymbolBase';
export class SymbolIterator extends WellKnownSymbolBase {
    constructor() {
        super(...arguments);
        this.symbol = WellKnownSymbol.iterator;
    }
}

//# sourceMappingURL=iterator.js.map
